import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ce96f00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex w-full align-items-center pl-s1" }

import { useTokenBalance } from '@/composables/token/useTokenBalance';
import { Token } from '@/sdk/entities/token';
import { Direction } from '@/store/modules/bridge/models/direction';
import { useCardanoBridge } from '@/store/modules/bridge/useCardanoBridge';
import { useAllWallets } from '@/store/modules/wallet/useAllWallets';
import { computed, ref } from 'vue';
import TokenPanel from './TokenPanel.vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import ControlIcon from '@/components/icon/ControlIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenSelect',
  props: {
    direction: null
  },
  emits: ['tokenSelected'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  direction: Direction;
}



const { getBlockchainByDirection, getTokenByDirection, getBlockchainTokens, setSelectedToken } =
  useCardanoBridge();
const { isWalletInjected } = useAllWallets();



const isShowDialog = ref(false);

const blockchain = getBlockchainByDirection(props.direction);
const blockchainName = computed(() => blockchain.value.name);

const selectedToken = getTokenByDirection(props.direction);

const tokenList = getBlockchainTokens(blockchainName);

const walletInjected = isWalletInjected(blockchainName);

const onShowDialog = () => {
  isShowDialog.value = true;
};
const onHideDialog = () => {
  isShowDialog.value = false;
};
const onSelectToken = (token: Token) => {
  emits('tokenSelected');
  setSelectedToken(props.direction, token);
  onHideDialog();
};
const balances = computed(() => tokenList.value.map(token => useTokenBalance(token).value));

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      class: "form-select p-dropdown pl-s2",
      onClick: onShowDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(TokenIcon, {
            "icon-src": _unref(selectedToken).tokenIconUrl,
            symbol: _unref(selectedToken).unwrapWETH().symbol,
            full: ""
          }, null, 8, ["icon-src", "symbol"]),
          _createVNode(ControlIcon, {
            name: "down",
            "no-hover": "",
            class: "ml-s1",
            onClick: onShowDialog
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      visible: isShowDialog.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((isShowDialog).value = $event)),
      header: "Select a token",
      modal: true,
      dismissableMask: "",
      class: "dialog-setting md:w-25rem w-full"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["mt-s4 select-token-list", { 'h-20rem overflow-y-auto scrollable pr-s0': _unref(tokenList).length > 5 }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokenList), (token, index) => {
            return (_openBlock(), _createBlock(TokenPanel, {
              token: token,
              balance: _unref(balances)[index],
              key: token.symbol,
              "is-wallet-injected": _unref(walletInjected),
              "hide-zero-balance": false,
              onClick: () => onSelectToken(token),
              class: "mt-s1"
            }, null, 8, ["token", "balance", "is-wallet-injected", "onClick"]))
          }), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})